export default "__VITE_ASSET__qbDWjzKn__"